import client from './client'

export async function fetchNotifications() {
  const { data } = await client.get('/api/v1/notifications')
  return data
}

export async function markNotificationRead(id) {
  await client.patch(`/api/v1/notifications/${id}/read`)
}

export async function markAllNotificationsRead() {
  await client.patch('/api/v1/notifications/read_all')
}
